<template>
    <b-row>
        <b-col md="12">
            <b-form-group label="Klistra in CSV">
                <b-form-textarea
                    class="no-wrap"
                    debounce="300"
                    rows="10"
                    @input="reparseCsv"
                    v-model="exportCsv.raw"
                ></b-form-textarea>
            </b-form-group>
        </b-col>
        <b-col md="12">
            <b-card no-body v-if="exportCsv.parsed.length">
                <b-card-header>
                    <b-row>
                        <b-col md="4">
                            <b-pagination
                                first-number
                                last-number
                                class="mx-auto"
                                v-model="exportCsv.currentPage"
                                :total-rows="exportCsv.parsed.length"
                                :per-page="exportCsv.perPage"
                                aria-controls="export-list"
                            ></b-pagination>
                        </b-col>
                        <b-col md="4">
                        </b-col>
                        <b-col md="4" class="flex-center-right">
                            <div v-if="exportCsv.parsed.length">
                                Visar {{ exportCsv.perPage }} av {{ exportCsv.parsed.length }}st
                            </div>
                        </b-col>
                    </b-row>
                </b-card-header>
                <b-table
                    id="export-list"
                    responsive
                    :items="exportCsv.parsed"
                    :perPage="exportCsv.perPage"
                    :current-page="exportCsv.currentPage"
                >
                </b-table>
                <div class="import-wrapper" style="padding: 1rem;">
                    <b-button
                        :variant="errorLevel"
                        :disabled="importLoading"
                        @click="importData"
                    >
                        <b-spinner v-if="importLoading" small></b-spinner>
                        <span v-if="!importLoading">
                            Importera lista {{ errorLevel === 'warning' ? ('med ' + this.messages.length + ' varningar') : '' }}
                        </span>
                        <span v-if="importLoading">
                            Behandlar listan...
                        </span>
                    </b-button>

                    <div v-if="progressCounter !== progressTotal" class="mt-2">
                        <p>{{ progressCounter }} / {{ progressTotal }}</p>
                        <b-progress :value="progressCounter" :max="progressTotal" height="2rem"></b-progress>
                    </div>
                </div>
            </b-card>
        </b-col>
        <b-col md="12">
            <div v-if="messages.length">
                <b-button
                    v-b-toggle.csv-collapse-1
                    :variant="errorLevel"
                    style="margin-bottom: 1rem"
                >
                    Inspektera {{ messages.length }}st problem
                </b-button>
                <b-collapse id="csv-collapse-1">
                    <b-card>
                        <b-alert show v-for="item in messages" variant="warning" v-bind:key="item">{{ item }}</b-alert>
                        <b-alert show v-if="messages.length">
                            <p>Allowed headers are:</p>
                            <ul>
                                <li v-for="(item, i_index) in allowedColumns" :key="i_index">{{ item }}</li>
                            </ul>
                            <div>
                                Example _> <br/>
                                <hr/>
                                email,first_name,last_name <br/>
                                sven.inge@supekort.se,Sven-Inge,Yolosson <br/>
                                test@test.com,Test,Testsson <br/>
                                yolo.yolossson@example.se,Yolo,Yolosson <br/>
                            </div>
                        </b-alert>
                    </b-card>
                </b-collapse>
            </div>
        </b-col>
    </b-row>
</template>
<script>
import apiClient from '@services/ApiClient';
import { notifySend } from '@services/Notify';

const defaultHeader = [
    'email',
    'first_name',
    'last_name',
    'variable_01',
    'variable_02',
    'variable_03',
    'variable_04',
    'variable_05',
    'variable_06',
    'variable_07',
    'variable_08',
    'variable_09',
    'variable_10',
    'test_card_mode',
];

export default {
    name: 'CsvImport',
    props: {
        startHeader: {
            required: false,
            default: () => defaultHeader.join(','),
        },
        allowedColumns: {
            required: false,
            default: defaultHeader,
        },
        apiEndpointUrl: {
            required: false,
            default: '/api/yolo/import',
        },
        validateItemOnParse: {
            type: Function,
            default() {},
        },
    },
    data() {
        return {
            loading: false,
            loadingMessage: '',
            importLoading: false,
            progressCounter: 0,
            progressTotal: 0,
            messages: [],
            importResults: {
                done: false,
                errored: [],
                data: [],
            },
            invalidForm: false,
            exportCsv: {
                raw: this.startHeader,
                parsed: [],
                perPage: 15,
                currentPage: 1,
            },
        };
    },
    computed: {
        errorLevel() {
            if (this.invalidForm) {
                return 'danger';
            }

            if (this.messages.length) {
                return 'warning';
            }

            return 'success';
        },
    },
    methods: {
        chunkArrayAction(array, callback, chunkLength) {
            let index;
            const arrayLength = array.length;
            for (index = 0; index < arrayLength;) {
                callback(array.slice(index, index + chunkLength));
                index += chunkLength;
            }
        },
        importData() {
            this.importLoading = true;
            this.progressCounter = 0;
            this.progressTotal = this.exportCsv.parsed.length;

            this.chunkArrayAction(this.exportCsv.parsed, async (recipientsChunk) => {
                const data = {
                    recipients: recipientsChunk,
                };

                await apiClient.post(
                    this.apiEndpointUrl,
                    data,
                ).then((res) => {
                    this.importLoading = false;

                    if (res.status === 200) {
                        this.$emit('csv:imported');
                    } else {
                        notifySend('Sparning avbröts', 'Sparning avbröts', 'error');
                    }

                    this.progressCounter += recipientsChunk.length;
                }).catch(() => {
                    this.importLoading = false;
                });
            }, 500);
        },
        resetImport() {
            this.importResults = {
                done: false,
                errored: [],
                data: [],
            };
            this.invalidForm = false;
            this.messages = [];
            this.exportCsv.parsed = [];
            this.exportCsv.raw = this.startHeader;
        },
        validateHeader(header) {
            header.forEach((item) => {
                if (!this.allowedColumns.includes(item)) {
                    this.messages.push('Unknown column: ' + item);
                }
            });
        },
        createNewItemObject() {
            const itemObject = {};

            this.allowedColumns.forEach((item) => {
                itemObject[item] = null;
            });

            return itemObject;
        },
        reparseCsv(data) {
            this.loading = true;
            this.invalidForm = false;
            this.messages = [];
            const rawData = data.split(/\r?\n/);
            const firstLine = rawData.shift().split(',').map((item) => item.replace(/['"]+/g, '').replace(' ', ''));

            this.validateHeader(firstLine);

            if (!firstLine.some((item) => item.includes('email'))) {
                this.messages.push('"email" column is required');
                this.invalidForm = true;
            }

            this.exportCsv.parsed = rawData
                .filter((item) => item.length)
                .map((item) => {
                    const splitItem = item.split(',');
                    const itemObject = this.createNewItemObject();
                    firstLine.forEach((itm, index) => {
                        if (splitItem[index]) {
                            itemObject[itm] = splitItem[index].replace(/['"]+/g, '').replace(' ', '');
                        }
                    });
                    this.validateItem(item, this);
                    return itemObject;
                });

            this.loading = false;
            this.$emit('input', this.exportCsv.parsed);
        },
        addMessage(msg) {
            this.messages.push(msg);
        },
        validateItem(item, instance) {
            this.validateItemOnParse(item, instance);
        },
    },
};
</script>
<style scoped>
.flex-center-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.no-wrap {
    white-space: nowrap;
}
.import-wrapper {
    display: grid;
}
</style>
